import props from './props'

export default {
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/components/graduations/resources/index.js